import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PAIN_CARDS } from '../../data/content';
export function Pain() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-163" data-mp="2dtwat3fl2o98">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="2dxbrubsti7da">
        <Reveal className="text-center" data-id="element-165" data-mp="2hxlxfncp6vrm">
          <SectionBadge data-id="element-166" data-mp="2hug9ibft1zxh">¿Te suena?</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-167" data-mp="2mwfbbgvwcosb">
            Si sos profesora de Danza Árabe, <span className="u-lime" data-id="element-168" data-mp="2rsw2yl2b1la5">seguramente alguna vez te pasó</span>
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-169" data-mp="2wnjr2itecdo7">
          {PAIN_CARDS.map((card, index) => <Reveal key={card.title} delay={index % 3 * 80} as="article" data-id="element-170" data-mp="31mcutjivsqb6" data-mpi={index}>
              <div className="h-full rounded-2xl border border-ink-line bg-ink p-5" data-id="element-171" data-mp="35npxxlulafee">
                <AlertCircleIcon className="h-5 w-5 text-lime" aria-hidden="true" data-id="element-172" data-mp="3alzyyd2zwa7x" />
                <h3 className="mt-3.5 text-base font-bold leading-snug text-snow" data-id="element-173" data-mp="20peevc947rph">{card.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-174" data-mp="1wlosmtfwxm7m">{card.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}